(() => {
  'use strict';
  if (window.PutaoyaoInquiryProduct) return;

  function selected(root) {
    return root.querySelector('[data-variant]:checked') || root.querySelector('[data-single]');
  }

  function update(root) {
    const option = selected(root);
    if (!option) return;
    const input = root.querySelector('[data-qty]');
    const quantity = Math.max(1, Number.parseInt(input?.value || '1', 10) || 1);
    const price = option.dataset.price || '';
    const output = root.querySelector('[data-price-output]');
    if (output) output.textContent = price;
    const fish = root.querySelector('wishlist-button-pdp');
    if (fish) {
      if (fish.getAttribute('data-variant-id') !== option.value) fish.setAttribute('data-variant-id', option.value);
      if (fish.getAttribute('data-preselected-id') !== option.value) fish.setAttribute('data-preselected-id', option.value);
    }
    const contact = root.querySelector('[data-contact]');
    if (contact && root.dataset.contactBase) {
      const parameters = new URLSearchParams({
        inquiry: 'product',
        product: root.dataset.title || '',
        handle: root.dataset.handle || '',
        variant: option.dataset.title || 'Default',
        qty: String(quantity),
        price
      });
      contact.href = root.dataset.contactBase + '?' + parameters.toString();
    }
  }

  function initialize(scope) {
    if (scope.matches?.('[data-py-inquiry-product]')) update(scope);
    scope.querySelectorAll?.('[data-py-inquiry-product]').forEach(update);
  }

  function onSelection(event) {
    const target = event.target;
    if (!(target instanceof Element) || !target.matches('[data-variant], [data-qty]')) return;
    const root = target.closest('[data-py-inquiry-product]');
    if (root) update(root);
  }

  window.PutaoyaoInquiryProduct = Object.freeze({ initialize });
  document.addEventListener('change', onSelection);
  document.addEventListener('input', onSelection);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
